import $ from 'jquery';

class FeaturedImageSlider{
  constructor() {
    this.links = $('.tertiary-links__link');
    this.slides = $('.pageTertiaryHeader__carousel');
    this.events();
  }

  events(){
    let vm = this;
    this.links.on('mouseover touchstart', function(){
      let target = $(this).attr('data-slide-to');
      if(target){
        vm.updateSlider('in', target);
      }
    });

    this.links.on('mouseout blur', function () {
      let target = $(this).attr('data-slide-to');
      if (target) {
        vm.updateSlider('out', target);
      }
    });
  }

  updateSlider(action, slide = ''){
    if(action === 'in'){
      this.slides.removeClass('active');
      $('.carousel--'+slide).addClass('active');
    }else{
      $('.carousel--' + slide).removeClass('active');
      $('.carousel--default').addClass('active');
    }
  }
}

export default FeaturedImageSlider;